import React, { useState } from 'react';
import { Modal, Form, Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import function from store folder */
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Editor from "../../../views/combination/editor";
import timestamp from '../../../assecs/plugin/timestamp'; 

const ViewMessage = () => {
    const { data } = useSelector(state => state.model);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState(data);
    const [messageImage] = useState(data.image);

    const cancelHandler = () => 
        dispatch(resetModel()
    );
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        _source[name] = value;

        setError(error);
        setSource(_source);
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>View data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" >
                    <div className="form-item">
                        <div className='label'>Message Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='msgName' defaultValue={ data.msgName } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Send Date</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='sendDate' defaultValue={ timestamp.get(data.sendDate) } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Message Type</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='type' defaultValue={ data.type } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Send Target</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='target' defaultValue={ data.target } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Status</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='status' defaultValue={ data.status } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Image</div>
                    </div>
                    <div className="form-item form-image-item">
                        { messageImage && <Image src={ messageImage } /> }
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } disabled readOnly={ true }/>
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ViewMessage;